import { formatTagLabel } from './formatTag';

/**
 * The words every surface that starts an AI document read uses to say WHAT it reads.
 *
 * The list is never written down here: it is `documentTypes` off
 * GET /api/document-extract/availability (services/ai/schemas EXTRACTABLE_DOCUMENT_TYPES),
 * so a type added to the reader shows up on the drop zone the same day. The entries are the
 * Title-Case registry labels ("Notice of Value"); `formatTagLabel` keeps them verbatim and
 * would still render a slug readably if one ever came through.
 *
 * It exists because an ATA staff member dropped an Engagement Letter into the property scan,
 * got "Could not identify this as a document type extraction can read", and had no way to
 * know which types it CAN read. The failure now names them, and the drop zone names them first.
 */

/** "Notice of Value, Tax Bill, Deed" — or '' when the list has not loaded. */
export function readableTypesList(documentTypes: readonly string[] | undefined): string {
  return (documentTypes ?? []).map((t) => formatTagLabel(t)).filter(Boolean).join(', ');
}

/** "Reads: Notice of Value, Tax Bill, Deed." for the point where a read can be started. */
export function readsSentence(documentTypes: readonly string[] | undefined): string | null {
  const list = readableTypesList(documentTypes);
  return list ? `Reads: ${list}.` : null;
}

/**
 * What to show when a read came back `unrecognized`: the reader did its job and this is not
 * one of its types. Names the types and points at the manual fix, which is always available.
 */
export function unrecognizedMessage(documentTypes: readonly string[] | undefined): string {
  const list = readableTypesList(documentTypes);
  const knows = list ? `It reads ${list}.` : 'It reads only a few document types.';
  return `Not a document type the reader knows. ${knows} If this is one of them, set the document type by hand and read it again.`;
}
